'use client';

import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import type { AppDispatch } from '@/lib/store';
import { incrementBlogViews } from '@/lib/store/slices/blogSlice';

/**
 * Fires a single view-count increment when a blog detail page mounts.
 * Guarded per blogId so React StrictMode double-effects and in-app
 * navigation between two posts never double-count.
 */
export default function ViewTracker({ blogId }: { blogId: string }) {
    const dispatch = useDispatch<AppDispatch>();
    const firedFor = useRef<string | null>(null);

    useEffect(() => {
        if (firedFor.current === blogId) return;
        firedFor.current = blogId;
        dispatch(incrementBlogViews(blogId));
    }, [dispatch, blogId]);

    return null;
}
